if (!customElements.get('thxsilk-product-offer')) {
  customElements.define('thxsilk-product-offer', class extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-copy-code]');
      this.status = this.querySelector('[data-copy-status]');
      if (!this.copyButton || !this.status || this.copyHandler) return;
      this.copyLabel = this.copyButton.textContent;
      this.defaultStatus = this.status.textContent;
      this.copyHandler = this.copyCode.bind(this);
      this.copyButton.addEventListener('click', this.copyHandler);
    }

    disconnectedCallback() {
      this.copyButton?.removeEventListener('click', this.copyHandler);
      this.copyHandler = null;
      clearTimeout(this.copyResetTimer);
      if (this.copyButton) {
        this.copyButton.textContent = this.copyLabel;
        this.copyButton.disabled = false;
      }
    }

    async copyCode() {
      const code = (this.dataset.code || '').trim();
      if (!code || this.copyButton.disabled) return;
      clearTimeout(this.copyResetTimer);
      this.copyButton.disabled = true;
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (_) {
        // Browser permission may prevent the modern clipboard API.
      }
      if (!copied) {
        const field = document.createElement('textarea');
        field.value = code;
        field.readOnly = true;
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        try {
          field.select();
          copied = document.execCommand('copy');
        } catch (_) {
          copied = false;
        } finally {
          field.remove();
          if (this.isConnected) this.copyButton.focus();
        }
      }
      if (!this.isConnected) return;
      this.copyButton.disabled = false;
      this.copyButton.textContent = copied ? 'Code copied' : this.copyLabel;
      this.status.textContent = copied
        ? this.defaultStatus
        : 'Please select and copy the code above, then enter it at checkout.';
      if (copied) {
        this.copyResetTimer = setTimeout(() => {
          if (this.isConnected) this.copyButton.textContent = this.copyLabel;
        }, 2000);
      }
    }
  });
}
